var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mediaType == 'photo')?_c('Photo',{staticClass:"view-media"}):_c('Video',{staticClass:"view-media"})}
var staticRenderFns = []

export { render, staticRenderFns }